module.exports = __webpack_public_path__ + "img/void.59f02e88.png";